module.exports = __webpack_public_path__ + "img/app-store-ios.455d4ddc.svg";